import { render, staticRenderFns } from "./RequestCallStatusBadge.vue?vue&type=template&id=30b9113a&scoped=true&"
import script from "./RequestCallStatusBadge.vue?vue&type=script&lang=js&"
export * from "./RequestCallStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./RequestCallStatusBadge.vue?vue&type=style&index=0&id=30b9113a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9113a",
  null
  
)

component.options.__file = "RequestCallStatusBadge.vue"
export default component.exports